import TrackerModel from 'models/tracker';


export default TrackerModel.extend({
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'profile',
  }),
  validate: function (attrs) {
    // Invalidate if either field is empty or only spaces
    var spaces_or_empty_re = /\S/;
    if (!spaces_or_empty_re.test(attrs.anchor_low) ||
                  !spaces_or_empty_re.test(attrs.anchor_high)
    ) {
      return 'Both fields must contain text';
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/models/profile.js